import React, { useEffect, useState } from 'react';
import './1v1.css';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSessionType } from '../../redux/onevone/onevoneSlice';
import { fetchDate } from '../../redux/onevone/onevoneSlice';
import { formatDate } from '../../utils/formatDate';
import { timeformatter } from '../../utils/timeformatter';
import { services } from '../../apis/index';
import Loader from '../../components/Loader';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import InterviewBooking from '../../components/InterviewBooking';
import { notifySuccess } from '../../components/notification';

import Recordings1v1 from '../../components/Recordings1v1';
import SessionFeedbackModal from '../../components/SessionFeedbackModal';


const style = {
	position: 'absolute' as const,
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: '#012555',
	color: '#fff',
	boxShadow: 24,
	p: 4,
};

const CancelConfirmModal = ({
	cancelConfirmOpen,
	handleClose,
	sessionId,
}: {
	cancelConfirmOpen: boolean;
	handleClose: any;
	sessionId: string;
}) => {
	const handlecancel = async () => {
		try {
			const res = await services.courseService.cancelSession(sessionId);
			console.log(res);
			notifySuccess('Session cancelled successfully!');
			window.location.reload();
		} catch (err) {
			console.log(err);
		}
	};
	return (
		<Modal
			open={cancelConfirmOpen}
			onClose={handleClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={style}
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '20px',
					borderRadius: '8px',
				}}
			>
				<Typography
					id="modal-modal-title"
					variant="h6"
					component="h2"
					style={{ textAlign: 'center' }}
				>
					Are you sure you want to cancel your interview?
				</Typography>
				<Button
					onClick={handlecancel}
					style={{ background: '#a71010' }}
					variant="contained"
				>
					Yes, I want to cancel my interview.
				</Button>
				<Button
					variant="contained"
					onClick={handleClose}
				>
					No
				</Button>
			</Box>
		</Modal>
	);
};

const NoshowConfirmModal = ({
	noshowConfirmOpen,
	handleClose,
	sessionId,
	user,
}: {
	noshowConfirmOpen: boolean;
	handleClose: any;
	user: any;
	sessionId: string;
}) => {
	const handleNoShow = async () => {
		const userType = user.roles[0] === 'mentor' ? 'MENTOR' : 'USER';
		const res = await services.courseService.markNoShow(
			sessionId,
			userType
		);

		window.location.reload();
	};
	if (user)
		return (
			<Modal
				open={noshowConfirmOpen}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={style}
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '20px',
						borderRadius: '8px',
					}}
				>
					<Typography
						id="modal-modal-title"
						variant="h6"
						component="h2"
						style={{ textAlign: 'center' }}
					>
						Are you sure you want to mark no show for this{' '}
						{user.roles[0] === 'mentor' ? 'user' : 'mentor'}?
					</Typography>
					<Button
						onClick={handleNoShow}
						style={{ background: '#a71010' }}
						variant="contained"
					>
						Yes, my{' '}
						{user.roles[0] === 'mentor' ? 'student' : 'mentor'}{' '}
						didn't join the meet.
					</Button>
					<Button
						variant="contained"
						onClick={handleClose}
					>
						No
					</Button>
				</Box>
			</Modal>
		);
	else return <div></div>;
};

const Onevone = () => {
	const feedbackAvailableSessions = [
		'abeaa856-a2d1-4929-b4f1-b929e55b8a8d',
		'3906c8fa-e7ab-4570-88ae-1736d678b781',
		'617971a6-4b5d-4102-9b51-c93142ac86d3',
		'f1e17870-c039-4427-9ffe-1eabef13204b',
		'57c2ad6c-b4af-44e8-a10e-62542784a1ac',
		'f52d4294-8e03-41af-9d80-f19f9b572da1',
		'0f44dda4-2c53-4a3f-881a-9d9eedc3d892',
		'fd1fcd49-dbea-45b2-80fa-e6cda6f48896',
		'c4bd011f-8bda-493e-930f-01cd1f2f1e71',
		'e0668195-d2cb-4ca4-a94e-ddc6c7cb4859',
		'c8ecbfdb-9d68-4db9-91f7-dbbfa132dba1',
		'3e646be3-f446-4edc-a4c3-738d6cb598c0',
		'42ddcf47-557f-4722-8ad4-e5e4bef4f8de',
		'bcccdcf4-aa3a-49f6-94b0-580414973039',
		'bd56adca-db95-4ced-9794-79996817cf65',
	];
	const { user } = useSelector((state: any) => state.user);
	const onevoneData = useSelector((state: any) => state.onevone);
	const {
		sessionData,
		noSession,
		status,
		date,
		sessionId,
		slot,
		error: { State, message },
	} = onevoneData;
	const [showRecordingsModal,setShowRecordingsModal]=useState(false)
	const [currentRoomId,setCurrentRoomId]=useState('')
	const [currentRecordings,setCurrentRecordings]=useState([])
	const [typeUser, setUserType] = useState('USER');
	const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false);
	const [noshowConfirmOpen, setNoshowConfirmOpen] = useState(false);
	const [cancelSessionId, setCancelSessionId] = useState('');

	const [feedbackOpen, setFeedbackOpen] = useState(false);
	const [feedbackQuestions, setFeedbackQuestions] = useState({});

	const handleFeedbackOpen = (questions: any) => {
		setFeedbackQuestions(questions);
		setFeedbackOpen(true);
	};

	const handleFeedbackClose = () => {
		setFeedbackOpen(false);
	};

	const handleOpen = (sessionId: string) => {
		setCancelSessionId(sessionId);
		setCancelConfirmOpen(true);
	};
	const [loading, setLoading] = useState(true);
	const handleClose = () => setCancelConfirmOpen(false);
	const handleCloseNoShow = () => setNoshowConfirmOpen(false);
	const dispatch = useDispatch();
	const [userId, setUserId] = useState('');


	const [signature,setSignature]=useState(null)


	const getSessionData = async () => {
		const userType = user.roles[0] === 'mentor' ? 'MENTOR' : 'USER';
		setUserType(userType);
		setUserId(user.id);
		const payload = { userType, userId: user.id };
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		await dispatch(fetchSessionType(payload));
		setLoading(false);
	};

	useEffect(() => {
		if (user !== null && sessionData === null) {
			getSessionData();
		} else {
			setLoading(false);
		}
	}, [user, sessionData]);

	const [interviewBookModal, setInterviewBookModal] = useState(false);
	const [rescheduleId, setRescheduleId] = useState(null);
	const handleInterviewBookModalClose = () => {
		// window.location.href = "https://precourse.acciojob.com";
		setInterviewBookModal(false);
	};

	const joinZoomVideoSDKSession = async (room: string) => {
		const userType = typeUser === 'MENTOR' ? 1 : 11;
		console.log(room,"sessionkey",typeof(room))
		// const role = userType==1?1:0;
		const role = 1
		const data = await services.sessionService.fetchZoomVideoSDKSignature(
			room,
			userId,
			userType,
			{
                "sessionName": room,
                "role": role,
                "sessionKey": room,
                "userIdentity": user.email
            }
              
        )
        .then((signature:any)=>{
            setSignature(signature);
			
            window.open(`https://meeting.acciojob.com/video?topic=${room}&role=${role}&sessionKey=${room}&userIdentity=${user.email}&signature=${signature}&name=${user.email}`,'_blank');
        
          });
		// console.log('fetch meeting link', data);
		// window.open(data, '_blank');
	};
	const joinSession = async (room: string) => {
		const userType = typeUser === 'MENTOR' ? 1 : 11;
		const data = await services.sessionService.fetchMeetingLink(
			room,
			userId,
			userType
		);
		console.log('fetch meeting link', data);
		window.open(data, '_blank');
	};
	const [selectedSessionId, setSelectedSessionId] = useState('');

	const handleshowRecordingsModal=()=>{
		setShowRecordingsModal(false)
	}


	const [isSessionMentorship, setIsSessionMentorship] = useState(false);

	const noShowState = (pstiv: any) => {
		return (
			new Date() >=
				new Date(
					new Date(pstiv.sessionDate).setMinutes(
						new Date(pstiv.sessionDate).getMinutes() + 15
					)
				) &&
			new Date() <=
				new Date(
					new Date(pstiv.sessionDate).setMinutes(
						new Date(pstiv.sessionDate).getMinutes() + 35
					)
				) &&
			((user.roles[0] === 'mentor' &&
				pstiv.mentorFeedback.length === 0) ||
				(user.roles[0] === 'maincourse-user' &&
					pstiv.studentFeedback.length === 0))
		);
	};

	if (loading || !sessionData) return <Loader />;


	return (
		<div className="one-v-one">
			{showRecordingsModal? (
				<Recordings1v1 
					open={showRecordingsModal}
					handleClose={handleshowRecordingsModal}
					currentRecordings={currentRecordings}
				/>
			):null}
				
			<CancelConfirmModal
				sessionId={cancelSessionId}
				cancelConfirmOpen={cancelConfirmOpen}
				handleClose={handleClose}
			/>
			<NoshowConfirmModal
				sessionId={cancelSessionId}
				noshowConfirmOpen={noshowConfirmOpen}
				handleClose={handleCloseNoShow}
				user={user}
			/>
			<SessionFeedbackModal
				open={feedbackOpen}
				handleClose={handleFeedbackClose}
				questions={feedbackQuestions}
			/>
			{interviewBookModal ? (
				<InterviewBooking
					open={interviewBookModal}
					handleClose={handleInterviewBookModalClose}
					sessionId={selectedSessionId}
					reloadData={getSessionData}
					rescheduleId={rescheduleId}
					isSessionMentorship={isSessionMentorship}
				/>
			) : null}
			<h3>1-1 Sessions</h3>
			{!noSession && !loading ? (
				<>
					<table>
						<thead>
							<tr className="firstRow">
								<th className="tableheadings">SESSION TYPE</th>
								<th className="tableheadings">DATE</th>
								<th className="tableheadings">
									{typeUser === 'USER'
										? 'MENTOR DETAILS'
										: 'USER DETAILS'}{' '}
								</th>
								<th className="tableheadings">FINAL SCORE</th>
								<th className="tableheadings">FEEDBACK</th>
							</tr>
						</thead>
						{sessionData !== null
							? sessionData.map((sn: any) => {
									let index = 0;
									return (
										<tbody key={index}>
											{/* <button
                                                                            className={
                                                                                'join-now-btn'
                                                                            }
                                                                            disabled={
                                                                                false
                                                                            }
                                                                            onClick={() => {
                                                                                joinZoomVideoSDKSession(
                                                                                    "40f02edf-4c6d-4276-9b78-e205558c0092"
                                                                                );
                                                                            }}
                                                                        >
                                                                            Join
                                                                            Now
                                                                        </button> */}
											{sn.upcomingInterviews.length > 0 &&
												sn.upcomingInterviews.map(
													(pstiv: any) => {
														index++;
														return (
															<tr key={index}>
																{index == 1 && (
																	<td
																		rowSpan={
																			sn
																				.upcomingInterviews
																				.length +
																			sn
																				.pastInterviews
																				.length +
																			sn
																				.rescheduledInterviews
																				.length +
																			sn
																				.cancelledInterviews
																				.length +
																			(sn.isfutureEligible
																				? 1
																				: 0)
																		}
																		className="module1"
																	>
																		{sn.sessionInfo.sessionType.toLowerCase()}
																	</td>
																)}
																<td>
																	{timeformatter(
																		new Date(
																			pstiv.sessionDate
																		),
																		false
																	)}
																</td>
																<td>
																	{
																		pstiv
																			.otherUserInfo
																			.firstName
																	}{' '}
																	{
																		pstiv
																			.otherUserInfo
																			.lastName
																	}
																	<br />{' '}
																	{
																		pstiv
																			.otherUserInfo
																			.phoneNumber
																	}
																	<br />{' '}
																	{typeUser ===
																		'MENTOR' && (
																		<>
																			<strong>
																				BM:
																			</strong>{' '}
																			{
																				pstiv.bmNumber
																			}
																		</>
																	)}
																</td>
																<td> -</td>
																<td className="feedback">
																	{pstiv.noshow ===
																		null &&
																	typeUser ===
																		'MENTOR' ? (
																		<p
																			onClick={() => {
																				window.open(
																					`${pstiv.session.feedbackLink}?sessionId=${pstiv.id}`,
																					'_blank'
																				);
																			}}
																		>
																			{/*View Feedback ➡️*/}
																			Fill
																			Feedback
																		</p>
																	) : (
																		<span>
																			-
																		</span>
																	)}
																</td>
																<td className="scheduled">
																	{pstiv.noshow &&
																	pstiv.noshow
																		.roles[0] ===
																		'mentor' ? (
																		<button
																			className={
																				'cancel-btn'
																			}
																		>
																			No
																			show
																			marked
																			by
																			Mentor
																		</button>
																	) : pstiv.noshow &&
																	  pstiv
																			.noshow
																			.roles[0] ===
																			'maincourse-user' ? (
																		<button
																			className={
																				'cancel-btn'
																			}
																		>
																			No
																			show
																			marked
																			by
																			Student
																		</button>
																	) : null}
																	{new Date() <
																		new Date(
																			new Date(
																				pstiv.sessionDate
																			).getTime() -
																				2 *
																					60 *
																					60 *
																					1000
																		) &&
																		user
																			.roles[0] !=
																			'mentor' && (
																			<button
																				className={
																					'cancel-btn'
																				}
																				onClick={() => {
																					handleOpen(
																						pstiv.id
																					);
																				}}
																			>
																				Cancel
																			</button>
																		)}
																	{pstiv.noshow ===
																		null &&
																		noShowState(
																			pstiv
																		) && (
																			<button
																				className={
																					'noshow-btn'
																				}
																				onClick={() => {
																					setCancelSessionId(
																						pstiv.id
																					);
																					setNoshowConfirmOpen(
																						true
																					);
																				}}
																			>
																				No
																				Show
																			</button>
																		)}
																	{user
																		.roles[0] !==
																		'mentor' &&
																		new Date() <
																			new Date(
																				new Date(
																					pstiv.sessionDate
																				).getTime() -
																					2 *
																						60 *
																						60 *
																						1000
																			) && (
																			<button
																				className={
																					'join-now-btn'
																				}
																				onClick={() => {
																					setSelectedSessionId(
																						pstiv
																							.session
																							.id
																					);
																					setIsSessionMentorship(sn.sessionInfo.isMentorShip)
																					setRescheduleId(
																						pstiv.id
																					);
																					setInterviewBookModal(
																						true
																					);
																				}}
																			>
																				Reschedule
																			</button>
																		)}

																	{pstiv.noshow ===
																		null && (
																		<button
																			className={
																				'join-now-btn'
																			}
																			disabled={
																				!pstiv.enableJoinNow
																			}
																			onClick={() => {
																				joinZoomVideoSDKSession(
																					pstiv.room
																				);
																			}}
																		>
																			Join
																			Now
																		</button>
																	)}
																</td>
															</tr>
														);
													}
												)}
											{sn.pastInterviews.length > 0 &&
												sn.pastInterviews.map(
													(pstiv: any) => {
														index++;
														return (
															<tr key={index}>
																{index == 1 ? (
																	<td
																		rowSpan={
																			sn
																				.upcomingInterviews
																				.length +
																			sn
																				.pastInterviews
																				.length +
																			sn
																				.rescheduledInterviews
																				.length +
																			sn
																				.cancelledInterviews
																				.length +
																			(sn.isfutureEligible
																				? 1
																				: 0)
																		}
																		className="module1"
																	>
																		{sn.sessionInfo.sessionType.toLowerCase()}
																	</td>
																) : null}
																<td>
																	{timeformatter(
																		new Date(
																			pstiv.sessionDate
																		),
																		false
																	)}{' '}
																</td>
																<td>
																	{
																		pstiv
																			.otherUserInfo
																			.firstName
																	}{' '}
																	{
																		pstiv
																			.otherUserInfo
																			.lastName
																	}
																	<br />{' '}
																	{
																		pstiv
																			.otherUserInfo
																			.phoneNumber
																	}
																	<br />{' '}
																	{typeUser ===
																		'MENTOR' && (
																		<>
																			<strong>
																				BM:
																			</strong>{' '}
																			{
																				pstiv.bmNumber
																			}
																		</>
																	)}
																</td>
																<td>
																	<strong>
																		{pstiv.noshow ===
																		null ? (
																			pstiv.noshow ===
																				null &&
																			pstiv
																				.studentFeedback
																				.length ===
																				0 &&
																			typeUser ===
																				'USER' ? (
																				<p
																					style={{
																						cursor: 'pointer',
																						color: '#2666be',
																					}}
																					onClick={() => {
																						window.open(
																							`${pstiv.session.studentFeedbackLink}?sessionId=${pstiv.id}`,
																							'_blank'
																						);
																					}}
																				>
																					{/*View Feedback ➡️*/}
																					Fill
																					Feedback
																				</p>
																			) : (
																				pstiv.score
																			)
																		) : (
																			'No Score'
																		)}
																	</strong>
																</td>
																<td className="feedback">
																	{pstiv.noshow ===
																		null &&
																	pstiv
																		.mentorFeedback
																		.length ===
																		0 &&
																	typeUser ===
																		'MENTOR' ? (
																		<p
																			onClick={() => {
																				window.open(
																					`${pstiv.session.feedbackLink}?sessionId=${pstiv.id}`,
																					'_blank'
																				);
																			}}
																		>
																			{/*View Feedback ➡️*/}
																			Fill
																			Feedback
																		</p>
																	) : pstiv.mentorFeedback &&
																	  typeUser ===
																			'USER' &&
																	  feedbackAvailableSessions.includes(
																			pstiv
																				.session
																				.id
																	  ) ? (
																		<Tooltip 
																			title={pstiv
																			.studentFeedback
																			.length ===
																			0 &&
																			typeUser === 'USER' ? "Please fill the feedback form":""}
																			placement='top'>
																			<Button
																				style={{fontSize:'11px',fontWeight:'bold'}}
																				onClick={() =>
																					pstiv
																					.studentFeedback
																					.length ===
																					0 &&
																				typeUser ===
																					'USER' ?  "":handleFeedbackOpen(
																						pstiv
																					)
																				}
																			>
																				View
																				Feedback
																				➡️
																			</Button>
																		</Tooltip>
																	) : (
																		'To be updated soon'
																	)}
																</td>
																<td className="recording">
																	{pstiv.noshow &&
																	pstiv.noshow
																		.roles[0] ===
																		'mentor' ? (
																		'No Show marked by Mentor'
																	) : pstiv.noshow &&
																	  pstiv
																			.noshow
																			.roles[0] ===

																			'maincourse-user' ? (
																		'No Show marked by user'
																	) : pstiv.recordings.length>0 ? (

																		<p
																			// onClick={() => {
																			// 	window.open(
																			// 		pstiv.videoDetails,
																			// 		'_blank'
																			// 	);
																			// }}
																			onClick = {() => {
																				setShowRecordingsModal(true);
																				setCurrentRoomId(pstiv.room);
																				setCurrentRecordings(pstiv.recordings)
																			}}
																		>
																			▶️
																			View
																			Recordings
																		</p>
																	) : (
																		'No Recordings Available'
																	)}
																</td>
															</tr>
														);
													}
												)}
											{sn.rescheduledInterviews.length >
												0 &&
												sn.rescheduledInterviews.map(
													(pstiv: any) => {
														index++;
														return (
															<tr key={index}>
																{index == 1 ? (
																	<td
																		rowSpan={
																			sn
																				.upcomingInterviews
																				.length +
																			sn
																				.pastInterviews
																				.length +
																			sn
																				.rescheduledInterviews
																				.length +
																			sn
																				.cancelledInterviews
																				.length +
																			(sn.isfutureEligible
																				? 1
																				: 0)
																		}
																		className="module1"
																	>
																		{sn.sessionInfo.sessionType.toLowerCase()}
																	</td>
																) : null}
																<td>
																	{timeformatter(
																		new Date(
																			pstiv.sessionDate
																		),
																		false
																	)}{' '}
																</td>
																<td>
																	{'No Info'}
																</td>
																<td>
																	<strong>
																		{
																			'No Score'
																		}
																	</strong>
																</td>
																<td className="feedback">
																	{
																		'No Feedback'
																	}
																</td>
																<td className="recording">
																	{
																		'Session Was Rescheduled'
																	}
																</td>
															</tr>
														);
													}
												)}
											{sn.cancelledInterviews.length >
												0 &&
												sn.cancelledInterviews.map(
													(pstiv: any) => {
														index++;
														return (
															<tr key={index}>
																{index == 1 ? (
																	<td
																		rowSpan={
																			sn
																				.upcomingInterviews
																				.length +
																			sn
																				.pastInterviews
																				.length +
																			sn
																				.rescheduledInterviews
																				.length +
																			sn
																				.cancelledInterviews
																				.length +
																			(sn.isfutureEligible
																				? 1
																				: 0)
																		}
																		className="module1"
																	>
																		{sn.sessionInfo.sessionType.toLowerCase()}
																	</td>
																) : null}
																<td>
																	{timeformatter(
																		new Date(
																			pstiv.sessionDate
																		),
																		false
																	)}{' '}
																</td>
																<td>
																	{'No Info'}
																</td>
																<td>
																	<strong>
																		{
																			'No Score'
																		}
																	</strong>
																</td>
																<td className="feedback">
																	{
																		'No Feedback'
																	}
																</td>
																<td className="recording">
																	{
																		'Session Cancelled'
																	}
																</td>
															</tr>
														);
													}
												)}
											{sn.isfutureEligible && (
												<tr className="expiryrow">
													{index == 0 ? (
														<td
															rowSpan={
																sn
																	.upcomingInterviews
																	.length +
																sn
																	.pastInterviews
																	.length +
																sn
																	.rescheduledInterviews
																	.length +
																sn
																	.cancelledInterviews
																	.length +
																(sn.isfutureEligible
																	? 1
																	: 0)
															}
															className="module1"
														>
															{sn.sessionInfo.sessionType.toLowerCase()}
														</td>
													) : null}
													<td>
														<div className="expiry">
															<div>
																<img
																	src={`${window.location.origin}/assets/images/stopwatch.svg`}
																	alt="clock"
																/>
															</div>
															<div>
																Expires in next
																7 days
															</div>
														</div>
													</td>
													<td>-</td>
													<td>-</td>
													<td>No feedback</td>
													<td
														className="now"
														style={{
															cursor: 'pointer',
														}}
														onClick={() => {
															setSelectedSessionId(
																sn.sessionInfo
																	.id
															);
															setIsSessionMentorship(sn.sessionInfo.isMentorShip)
															setInterviewBookModal(
																true
															);
														}}
													>
														<p>Schedule Now ➡️</p>
													</td>
												</tr>
											)}
										</tbody>
									);
							  })
							: null}
					</table>
					<h5 style={{ textAlign: 'center', padding: '10px' }}>
						<u>Warning:</u> Please remember you can only
						cancel/reschedule a 1v1 session maximum 3 times during
						the course
					</h5>
				</>
			) : loading ? (
				<Loader />
			) : (
				<p className={'no-session'}>No upcoming sessions as of now</p>
			)}
		</div>
	);
};

export default Onevone;
